












import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapResolver from '../../util/MapResolver';
@Component({
    name: 'SearchTipPanel',
    mixins: [MapResolver],
})
export default class SearchTipPanel extends Vue {
    @Injectable() public container!: Container;
    @Prop() public tipPanelDatas: any;
    @Prop() public messageDetailData: any;


    public suggests: any[] = [];
    public commonKeyword: any = '';
    public aroundKeyword: any = '';
    private checked: any = -1;
    private aroundChecked: any = -1;
    constructor() {
        super();
    }



    @Watch('tipPanelDatas')
    public handleResultData(val: any) {
        if (val.baidu) {
            this.suggests = val.baidu.suggests;
            this.commonKeyword = this.$store.state.searchStore.commonKeyword;
            this.aroundKeyword = this.$store.state.searchStore.aroundKeyword;
        }
    }




    public async handleClickSearch(keyWord: any) {
        this.$store.dispatch('searchStore/isShowPathIconEmit', false);

        if (this.$store.state.searchStore.isShowRoundFlag) {
            // 这里点击后虽然附近关键词变化了，但是不用重新查
            if (this.$store.state.searchStore.aroundKeyword !== keyWord) {
                this.$store.dispatch('searchStore/isChangeAroundKeyFlagEmit', true);
            }
            this.$store.dispatch('searchStore/aroundKeywordEmit', keyWord);
        } else {
            // 这里点击后虽然普通关键词变化了，但是不用重新查
            if (this.$store.state.searchStore.commonKeyword !== keyWord) {
                this.$store.dispatch('searchStore/isChangeCommonKeyFlagEmit', true);
            }
            this.$store.dispatch('searchStore/commonKeywordEmit', keyWord);
        }

        // 关闭本面板
        this.$store.dispatch('searchStore/isShowTipPanelEmit', false);


        try {
            // 加载地图组件
            const component: any = await this.getComponent('Toolbar', 'RegeoCode');
            const searchComp: any = await this.getComponent();
            // 接入真实数据
            if (this.$store.state.searchStore.isShowRoundFlag) {
                const location = this.messageDetailData.data.location.x + ',' + this.messageDetailData.data.location.y;
                const region = this.messageDetailData.data.city ? this.messageDetailData.data.city : '1';
                const opt = {
                    keyword: this.$store.state.searchStore.aroundKeyword,
                    query_type: 2,
                    location,
                    region,
                    radius: 1000,
                };
                searchComp.aroundSearch(opt).then((dataList: any) => {
                    this.$emit('searchResultDatasEmit', dataList);
                });
            } else {
                component.regeocode().then((result: any) => {
                    const opt = {
                        keyword: this.$store.state.searchStore.commonKeyword,
                        query_type: 2,
                        region: result,
                    };
                    searchComp.keywordSearch(opt).then((dataList: any) => {
                        this.$emit('searchResultDatasEmit', dataList);
                    });
                });
            }

        } catch (err) {
            console.log('周边建议词查询列表接口请求失败', err);
        }

    }

    public mounted() {
        this.watchDownUp();
    }

    @Watch('$store.state.searchStore.isShowTipPanel')
    private onChangeShowTipPanel(val: any) {
        if (!val) {
            this.aroundChecked = -1;
            this.checked = -1;
        }
    }

    private watchDownUp() {
        $(window).keydown((ev: any) => {
            const event = ev || window.event;
            // 上键
            if (event.keyCode === 38) {
                this.keyboardUp();
            }
            // 下键
            if (event.keyCode === 40) {
               this.keyboardDown();
            }
            if (event.keyCode === 13) {
                if (this.$store.state.searchStore.isShowRoundFlag) {
                    if (this.aroundChecked !== -1) {
                        this.handleClickSearch(this.suggests[this.aroundChecked].name);
                        this.aroundChecked = -1;
                    } else {
                        this.handleClickSearch(this.aroundKeyword);

                    }

                } else {
                    if (this.checked !== -1) {
                        this.handleClickSearch(this.suggests[this.checked].name);
                        this.checked = -1;
                    } else {
                        this.handleClickSearch(this.commonKeyword);

                    }


                }




            }
        });
    }

    private keyboardUp() {
        const length = this.suggests.length;
        if (this.$store.state.searchStore.isShowRoundFlag) {
            this.$store.dispatch('searchStore/isChangeAroundKeyFlagEmit', true);
            if (this.aroundChecked === -1) {
                this.aroundChecked = length - 1;
                this.$store.dispatch('searchStore/aroundKeywordEmit', this.suggests[this.aroundChecked].name);
            } else {
                if (this.aroundChecked > 0) {
                    this.aroundChecked --;
                    this.$store.dispatch('searchStore/aroundKeywordEmit', this.suggests[this.aroundChecked].name);
                } else {
                    this.aroundChecked = -1;
                    this.$store.dispatch('searchStore/aroundKeywordEmit', this.aroundKeyword);
                }
            }
        } else {
            this.$store.dispatch('searchStore/isChangeCommonKeyFlagEmit', true);
            if (this.checked === -1) {
                this.checked = length - 1;
                this.$store.dispatch('searchStore/commonKeywordEmit', this.suggests[this.checked].name);

            } else {
                if (this.checked > 0) {
                    this.checked --;
                    this.$store.dispatch('searchStore/commonKeywordEmit', this.suggests[this.checked].name);
                } else {
                    this.checked = -1;
                    this.$store.dispatch('searchStore/commonKeywordEmit', this.commonKeyword);
                }
            }
        }
    }
    private keyboardDown() {
        const length = this.suggests.length;
        if (this.$store.state.searchStore.isShowRoundFlag) {
            this.$store.dispatch('searchStore/isChangeAroundKeyFlagEmit', true);
            if (this.aroundChecked < (length - 1)) {
                this.aroundChecked ++;
                this.$store.dispatch('searchStore/aroundKeywordEmit', this.suggests[this.aroundChecked].name);
            } else {
                this.aroundChecked = -1;
                this.$store.dispatch('searchStore/aroundKeywordEmit', this.aroundKeyword);
            }
        } else {
            this.$store.dispatch('searchStore/isChangeCommonKeyFlagEmit', true);
            if (this.checked < (length - 1)) {
                this.checked ++;
                this.$store.dispatch('searchStore/commonKeywordEmit', this.suggests[this.checked].name);
            } else {
                this.checked = -1;
                this.$store.dispatch('searchStore/commonKeywordEmit', this.commonKeyword);
            }
        }
    }



    private getComponent(moduleName: string = 'Search', componentName: string = 'POISearch') {
        const p = new Promise((resolve, reject) => {
            (this as any).resolveMap('map').then((data: any) => {
                const temp: any = this;
                const facotory = temp.container.resolve('mapShare').comFactory;
                const component = facotory.getComponent(moduleName, componentName);
                resolve(component);
            }).catch(() => { reject('获取地图组件失败'); });
        });
        return p;
    }
}
